<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'

const { t } = useI18n()
const route = useRoute()

const TABS = [
  { name: 'reporting-overview', labelKey: 'reporting.tabs.overview' },
  { name: 'reporting-income-expenses', labelKey: 'reporting.tabs.incomeExpenses' },
  { name: 'reporting-accounts', labelKey: 'reporting.tabs.accounts' },
  { name: 'reporting-categories', labelKey: 'reporting.tabs.categories' },
  { name: 'reporting-payees', labelKey: 'reporting.tabs.payees' },
  { name: 'reporting-tags', labelKey: 'reporting.tabs.tags' },
  { name: 'reporting-trends', labelKey: 'reporting.tabs.trends' },
  { name: 'reporting-net-worth', labelKey: 'reporting.netWorthTitle' },
  { name: 'reporting-period-rollup', labelKey: 'reporting.periodRollupTitle' },
  { name: 'reporting-parent-rollup', labelKey: 'reporting.tabs.childSummary' },
  { name: 'reporting-lent-to', labelKey: 'reporting.tabs.lentTo' },
] as const
</script>

<template>
  <nav :aria-label="t('reporting.title')" class="flex min-w-0 gap-[var(--space-inline)] overflow-x-auto">
    <RouterLink
      v-for="tab in TABS"
      :key="tab.name"
      :to="{ name: tab.name, query: route.query }"
      class="flex min-h-[var(--density-target-min)] shrink-0 items-center px-[var(--space-cell)] py-[var(--space-inline)] text-[length:var(--text-step-3)] font-medium"
      :class="
        route.name === tab.name
          ? 'border-b-2 border-[color:var(--color-accent)] text-[color:var(--color-text)]'
          : 'text-[color:var(--color-text-muted)]'
      "
      :aria-current="route.name === tab.name ? 'page' : undefined"
    >
      {{ t(tab.labelKey) }}
    </RouterLink>
  </nav>
</template>
